import * as React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';

import {IContentBlock} from 'features/blocks/types';
import {useDeviceStore, selectIsMobile} from 'features/ui/store/useDeviceStore';
import {sanitizeHtml} from 'features/services/utils/sanitize-html';
import {LinkStyle, ReadMoreAlign, HeadlineLevel} from 'features/ui/enums';

import 'components/blocks/ImageAndVideo/PromotionBlock/style.scss';

import {A} from '@atoms/LinksAndButtons/A';
import {P} from '@atoms/Text/P';
import {Icon} from '@atoms/Media/Icon';
import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';
import {ReadMore} from '@atoms/LinksAndButtons/ReadMore';
import {EpiImage} from "features/search/types";
import {Headline} from '@atoms/Text/Headline';

interface PromotionBlockType {
    title: string;
    content?: string;
    linkUrl: string;
    image: EpiImage;
    linkButton: boolean;
    isSuccessionBlock?: boolean;
}
type Props = IContentBlock<PromotionBlockType>;

export const PromotionBlock: React.FunctionComponent<Props> = ({data, id, index: _index}) => {

    const _isMobile = useDeviceStore(selectIsMobile);

    const classes = classNames('promotion-block', {
        'promotion-block--succession': data.isSuccessionBlock,
    });

    return (
        <A
            variant={LinkStyle.UNSTYLED}
            href={data.linkUrl}
            route={!data.isSuccessionBlock}
            className={classes}
            id={id}
            target="_blank" 
            title={data.title}
        >
            <div className="promotion-block__image" style={{backgroundImage: data.image ? 'url(' + data.image.url + ')' : ''}}>
                {/* <AsyncImage
                    fullWidth
                    image={data.image}
                    quality={
                        index === 0 ?
                            ImageSizes.SIZE_1200 :
                            isMobile ?
                                ImageSizes.SIZE_900 :
                                ImageSizes.SIZE_1200
                    }
                    alt={data.title}
                /> */}
            </div>
            <div className="promotion-block__content">
                <div className="promotion-block__content-wrapper">
                    <Headline level={HeadlineLevel.H3} darkBg={!data.isSuccessionBlock}>{data.title}</Headline>

                    {data.linkButton &&
                        <div>
                            {data.content &&
                                <P dangerouslySetInnerHTML={{__html: sanitizeHtml(data.content)}} />
                            }
                            <Button 
                                onClick={() => {}} 
                                buttonColor={ButtonColor.LIGHT} 
                                buttonSize={ButtonSize.DEFAULT} 
                                buttonType={ButtonType.GHOST}
                            >
                                <FormattedMessage id="jm.components.PromotionBlock.readMore" />
                            </Button>
                        </div>
                    }

                    {!data.linkButton &&
                        <div>
                            {data.content &&
                                <div dangerouslySetInnerHTML={{__html: sanitizeHtml(data.content)}} />
                            }
                            { !data.isSuccessionBlock && <ReadMore block bold darkBg align={ReadMoreAlign.CENTER} />}
                            { data.isSuccessionBlock &&  <span className="promotion-block__link">Se bostäderna <Icon name="external-link" size={20} /></span>}
                        </div>
                    }
                </div>
            </div>
        </A>
    )
};

